<template>
  <div class="backDiv">
    <div class="bookTitle">
      {{ currentQueryResult.PeriodInfoName + "考试准考证" }}
    </div>
    <table class="bookContent">
      <tr>
        <td class="pt80">
          <p
            class="bookImage"
            v-if="
              currentQueryResult &&
              currentQueryResult.AttachList &&
              currentQueryResult.AttachList.length > 0
            "
          >
            <img :src="currentQueryResult.AttachList[0].url" />
          </p>
          <p>姓&emsp;&emsp;名：{{ currentQueryResult.Name }}</p>
          <p>性&emsp;&emsp;别：{{ currentQueryResult.Sex }}</p>
          <p>准考证号：{{ currentQueryResult.IDCard }}</p>
          <p>身份证号：{{ currentQueryResult.IDCard }}</p>
          <p>人员类别：{{ currentQueryResult.MenTypeName }}</p>
          <p>工作单位：{{ currentQueryResult.WorkSite }}</p>
          <p>考试地点：{{ currentQueryResult.ExamSiteName }}</p>
          <p>地&emsp;&emsp;址：{{ currentQueryResult.ExamAddress }}</p>
          <p>候考地点：{{ currentQueryResult.ExamWaitSite }}</p>
          <p>考试时间：{{ currentQueryResult.ExamTime }}</p>
          <p>
            进场序号：{{
              currentQueryResult.ExamOrderString
            }}号（考生按此编号依次进入考场）
          </p>
        </td>
        <td>
          <p class="bookNotice">考 生 须 知</p>
          &emsp;&emsp;1、考生须按《准考证》通知的考试时间，持本人身份证原件和《准考证》提前15分钟到考试点，疫情常态化防控期间，不建议人员聚集，尽量不要提前15分钟以上到达考场。
          <br />
          &emsp;&emsp;2、考生务必佩戴口罩，人脸比对通过后进入考场，如考生未签字进入考场答题交卷后，一经发现按缺考处理。<br />
          &emsp;&emsp;3、考生不得携带任何书籍、资料进入考场，考试过程中请关闭手机等通信设备。
          <br />
          &emsp;&emsp;4、考生在考试过程中如有疑问或出现故障，请举手示意，由监考人员协助处理，擅自操作造成的后果由考生负责。<br />
          &emsp;&emsp;5、考场内要保持安静，不得交头接耳、大声喧哗，情节严重的取消考试资格。<br />
          &emsp;&emsp;6、考生答题结束后，点击“提交试卷”交卷，显示成绩后，方可离开考场。
          <br />
          &emsp;&emsp;7、向考场外发送、传递试题信息的；使用相关设备接收信息实施作弊的；伪造、变造身份证、准考证及其他证明材料，由他人代替或者代替考生参加考试的，一经发现，成绩作废。
        </td>
      </tr>
    </table>
    <div class="bookBottom">
      注：如发生火灾、地震等情况，请听从现场工作人员的指挥，不要慌乱，有序撤离。
    </div>
  </div>
</template>

<script>
export default {
  name: "ExamBook",
  data() {
    return {
      currentQueryResult: {},
    };
  },
  methods: {
    BackToIndex() {
      this.$router.push("/");
    },
  },
  activated() {
    let cacheData = localStorage.getItem("printResultData");
    if (!cacheData) {
      this.$router.push("/");
      return;
    }
    this.currentQueryResult = JSON.parse(cacheData);
    //console.log(this.currentQueryResult);
    window.print();
    //自动关闭窗口页面
    setTimeout(() => {
      window.close();
    }, 300);
  },
  created() {},
};
</script>
<style scoped>
.pt80 {
  padding-top: 80px !important;
}

.backDiv {
  width: 100%;
  padding: 20px;
}

.bookImage {
  position: absolute;
  top: 85px;
  left: 240px;
}

.bookImage img {
  width: 100px;
}

.bookTitle {
  font-size: 24px;
  text-align: center;
  font-weight: bold;
}

.bookContent {
  width: 100%;
  border-top: 1px solid black;
  border-bottom: 1px solid black;
  border-right: 1px solid black;
  margin-top: 20px;
}

.bookContent td {
  width: 50%;
  height: 780px;
  padding: 29px 9px 9px 9px;
  line-height: 25px;
  vertical-align: top;
  border-left: 1px solid black;
}

.bookNotice {
  font-size: 20px;
  font-weight: bold;
  text-align: center;
}

.bookBottom {
  margin-top: 20px;
  font-size: 18px;
  font-family: "仿宋";
}
</style>



// WEBPACK FOOTER //
// src/views/ExamBook.vue